import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["src", "width", "height"];
import { ref, watch, onMounted } from "../../../../adapter-vue";
import { isPC } from "../../../../utils/env";
import { handleSkeletonSize } from '../../utils/utils';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-image',
  props: {
    content: {
      "default": function _default() {
        return {};
      }
    },
    messageItem: {
      "default": function _default() {
        return {};
      }
    }
  },
  emits: ["previewImage"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var props = __props;
    var skeletonDomRef = ref();
    onMounted(function () {
      var _props$messageItem, _props$messageItem2, _props$messageItem3;
      if (((_props$messageItem = props.messageItem) === null || _props$messageItem === void 0 ? void 0 : _props$messageItem.status) === "success" || ((_props$messageItem2 = props.messageItem) === null || _props$messageItem2 === void 0 ? void 0 : _props$messageItem2.status) === "fail" || ((_props$messageItem3 = props.messageItem) === null || _props$messageItem3 === void 0 ? void 0 : _props$messageItem3.progress) === 1) {
        autoFixSkeletonSize();
      }
    });
    watch(function () {
      return props.content.height;
    }, function (newVal, oldVal) {
      if (newVal > oldVal) {
        autoFixSkeletonSize();
      }
    });
    function autoFixSkeletonSize() {
      var _document$getElementB, _skeletonDomRef$value, _skeletonDomRef$value2;
      var _props$content = props.content,
        _props$content$width = _props$content.width,
        width = _props$content$width === void 0 ? 0 : _props$content$width,
        _props$content$height = _props$content.height,
        height = _props$content$height === void 0 ? 0 : _props$content$height;
      if (width === 0 || height === 0) return;
      var containerWidth = ((_document$getElementB = document.getElementById("app")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.clientWidth) || 0;
      var max = !isPC ? Math.min(containerWidth - 180, 300) : 300;
      var size = handleSkeletonSize(width, height, max, max);
      (skeletonDomRef === null || skeletonDomRef === void 0 || (_skeletonDomRef$value = skeletonDomRef.value) === null || _skeletonDomRef$value === void 0 ? void 0 : _skeletonDomRef$value.style) && (skeletonDomRef.value.style.width = "".concat(size.width, "px"));
      (skeletonDomRef === null || skeletonDomRef === void 0 || (_skeletonDomRef$value2 = skeletonDomRef.value) === null || _skeletonDomRef$value2 === void 0 ? void 0 : _skeletonDomRef$value2.style) && (skeletonDomRef.value.style.height = "".concat(size.height, "px"));
    }
    function toggleShow() {
      var _props$messageItem4, _props$messageItem5;
      if (((_props$messageItem4 = props.messageItem) === null || _props$messageItem4 === void 0 ? void 0 : _props$messageItem4.status) === "success" || ((_props$messageItem5 = props.messageItem) === null || _props$messageItem5 === void 0 ? void 0 : _props$messageItem5.progress) === 1) {
        emits("previewImage", props.messageItem);
      }
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": "imageContainer",
        onClick: _withModifiers(toggleShow, ["self"]),
        ref_key: "skeletonDomRef",
        ref: skeletonDomRef
      }, [_createElementVNode("img", {
        "class": _normalizeClass(['messageImage', !_unref(isPC) && 'messageImage-h5']),
        src: props.content.url,
        width: props.content.width,
        height: props.content.height
      }, null, 10, _hoisted_1)], 512);
    };
  }
});